import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Item } from 'app/models/item.inferface';
import { ConfigsLoaderService } from './config-loader.service';
import { UserItem } from 'app/models/user-item.model';


@Injectable({
    providedIn: 'root'
})
export class CollaboratorService {
    private apiEndPoint: string;

    constructor(
        private http: HttpClient,
        private config: ConfigsLoaderService) {
        this.apiEndPoint = this.config.apiUrl;
    }

    search(endpoint: string, name: string): Observable<UserItem[]> {
        return this.http.get<UserItem[]>(`${this.apiEndPoint}/${endpoint}/${name}`);
    }

    searchPills(text: string): Observable<UserItem[]> {
        return this.http.get<UserItem[]>(`${this.apiEndPoint}/User/GetUsers/${text}`);
    }
    searchTechnicians(text: string): Observable<UserItem[]> {
        return this.http.get<UserItem[]>(`${this.apiEndPoint}/User/GetTechnicians/${text}`);
    }

    searchCollaboratorForRoleId(text: string, roleId: number): Observable<Item[]> {
        return this.http.get<Item[]>(`${this.apiEndPoint}/Collaborators/DirectorGetDataSource/${text}/${roleId}`);
    }
}
